import React, { useEffect, useState } from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatDate } from './../helper/formatDate';
import '../commonCss/classesCss.css'
import { useTranslate } from './TranslationText';
import axiosBackend from '../axios/axios';
import { getOrdinal } from '../helper/getOrdinal';
import { convertToCamelCase } from '../helper/convertToCamelCase';
import CustomButton from './CustomButton';
import HorseResultsTable from './HorseResultsTable';
import HorseList from './HorseList';
import ClassAccordion from './ClassAccordion';

export default function ClassesSection({ showID, newUpdate = 0, islive = false, handleHorseimages , showData }) {
    const { translate } = useTranslate();
    const [days, setClasses] = useState([]);
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';
    const [expandedDay, setExpandedDay] = useState(false);
    const [expandedClass, setExpandedClass] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [currentHorseId, setCurrentHorseId] = useState('');
    const [currentHorseData, setCurrentHorseData] = useState({});
    async function GetShowClassHorseSoringDetailsWithGallery(horseId = "") {
        try {
            const res = await axiosBackend.get(`/api/Show/GetShowClassHorseSoringDetailsWithGallery?ShowClassHorseId=${horseId}`);
            if (res?.data?.responseCode == "200") {
                setCurrentHorseData(res?.data?.result)
            }

        } catch (error) {

        }

    }

    async function GetHorseSoringWithGallery(horseNumber) {
        try {
            const res = await axiosBackend.get(`/api/Show/GetHorseSoringWithGallery?ShowId=${showID}&HorseNo=${horseNumber}`);
            if (res?.data?.responseCode == "200") {
                setCurrentHorseData(res?.data?.result)
            }
        } catch (error) {

        }
    }

    const handleChange =
        (panel, id, horseNumber) => (event, isExpanded) => {
            if (isExpanded) {
                setCurrentHorseData({});
            }
            if (islive) {
                setCurrentHorseId(id);
                GetShowClassHorseSoringDetailsWithGallery(id);
            } else {
                GetHorseSoringWithGallery(horseNumber);
            }
            setExpanded(isExpanded ? panel : false);
        };
    const handleChangeDay =
        (panel) => (event, isExpanded) => {
            setExpandedDay(isExpanded ? panel : false);
            setExpanded(false);
            setExpandedClass(false);
        };
    const handleChangeClass =
        (panel) => (event, isExpanded) => {
            setExpandedClass(isExpanded ? panel : false);
            setExpanded(false);
        };

    async function getClasses() {
        try {
            const res = await axiosBackend.get(`/api/Show/GetShowClasses?id=${showID}`);

            console.log('classes is', res.data);
            setClasses(res?.data?.result ?? []);

        } catch (error) {
            console.error('error in getting Classes')
        }

    }



    useEffect(() => {
        getClasses();
        if (islive) {
            if (currentHorseId !== "") {
                GetShowClassHorseSoringDetailsWithGallery(currentHorseId);
            }
        }
    }, [newUpdate])


    return (
        days.length > 0 &&
        <div className='mb-2'>
            <h2 className='roboto-custom-black' >{translate('web.classes', 'Classes')}</h2>
            {days.length > 0 && days.map((day, index) => (
                <Accordion className='mb-3' expanded={expandedDay === ('panelDay' + index)} onChange={handleChangeDay('panelDay' + index)}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon className='text-white fw-bold' />}
                        aria-controls="panel-content"
                        id="panel-header"
                        focusVisibleClassName='bg-success'
                        className='bg-dark text-white fw-bold'
                    >
                        {new Date(day?.dayDate).toLocaleDateString(`${currentLanguage}-EG-u-nu-latn`, {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })}
                    </AccordionSummary>
                    <AccordionDetails>
                        {day.showClassesList.map((item, index) => (
                            <ClassAccordion showData={showData} expandedClass={expandedClass} index={index} handleChangeClass={handleChangeClass} item={item} expanded={expanded} handleChange={handleChange} islive={islive} currentHorseData={currentHorseData} handleHorseimages={handleHorseimages} selectedHorseId={currentHorseId} />
                        ))}
                        {day?.championships.map((item, index) =>
                            <ClassAccordion showData={showData} isChampion={true} expandedClass={expandedClass} index={(day?.showClassesList?.length ?? 0) + index} handleChangeClass={handleChangeClass} item={item} expanded={expanded} handleChange={handleChange} islive={islive} currentHorseData={currentHorseData} handleHorseimages={handleHorseimages} selectedHorseId={currentHorseId} />
                        )}
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    )
}

